import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.dialysislist, { type, payload }) {
    switch (type) {
        case types.DISLYSISLIST_REQUEST:
            return {
                ...initialState.dialysislist,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.DISLYSISLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.DISLYSISLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}